import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ThemeMode {
  dark: boolean;
  light: boolean;
  semiDark: boolean;
  themeColor: string;
  layout: string;
  rtl: boolean;
}

export interface ConfigState {
  themeMode: ThemeMode;
}

const initialState: ConfigState = {
  themeMode: {
    dark: false,
    light: true,
    semiDark: false,
    themeColor: 'lite-purple',
    layout: 'large-sidebar',
    rtl: false,
  },
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    changeThemeMode(state) {
      const isDark = !state.themeMode.dark;
      state.themeMode.dark = isDark;
      state.themeMode.light = !isDark;
      state.themeMode.semiDark = false;
    },
    changeThemeLayout(state, action: PayloadAction<string>) {
      state.themeMode.layout = action.payload;
    },
    changeThemeRtl(state) {
      state.themeMode.rtl = !state.themeMode.rtl;
    },
    setThemeColor(state, action: PayloadAction<string>) {
      state.themeMode.themeColor = action.payload;
    },
    setRtl(state, action: PayloadAction<boolean>) {
      state.themeMode.rtl = action.payload;
    },
  },
});

export const { changeThemeMode, changeThemeLayout, changeThemeRtl, setThemeColor, setRtl } = configSlice.actions;

export const selectThemeMode = (state: { config: ConfigState }) => state.config.themeMode;
export const selectIsDark = (state: { config: ConfigState }) => state.config.themeMode.dark;
export const selectIsLight = (state: { config: ConfigState }) => state.config.themeMode.light;
export const selectIsSemiDark = (state: { config: ConfigState }) => state.config.themeMode.semiDark;
export const selectThemeColor = (state: { config: ConfigState }) => state.config.themeMode.themeColor;
export const selectLayout = (state: { config: ConfigState }) => state.config.themeMode.layout;
export const selectIsRtl = (state: { config: ConfigState }) => state.config.themeMode.rtl;

export default configSlice.reducer;
